import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError.js';
import { Toast } from '../../../../../../Notification/index.js';

const deleteTourActivityFlag = async ({ state, userId, removeTourActivityFlag, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourActivityFlagId, tourActivityFlagStartTime } = itemDetails;
  let parameters = {
    tourActivityFlagId,
    updatingUserId: userId,
  };
  const day = moment(tourActivityFlagStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Activity Flag Deleted', description: `For ${resource.name} on ${day}`};
  try {
    await removeTourActivityFlag(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeTourActivityFlag',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Activity Flag Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default deleteTourActivityFlag;
